import React from "react";
import {
  GA_DATA_USE_URL,
  GA_OPT_OUT_URL,
  LEGAL_ESTABLISHED_DATE,
  getDeletionRequestFormUrl,
} from "../data/siteContact";

// ⚠ この本文はサイト運営者の最終確認を受けていない。公開前に必ず内容を確認すること。
// 利用者に見える場所へ「ドラフト」と書くとポリシーとしての効力に疑義が生じるため、
// 注記は利用者向けには出さず、このコメントで管理する。
const Privacy = () => {
  const deletionFormUrl = getDeletionRequestFormUrl();

  return (
    <main className="legal-page" aria-labelledby="privacy-title">
      <h1 id="privacy-title">プライバシーポリシー</h1>
      <p>
        このプライバシーポリシーは、個人が非商用で運営する「Gundam War Portal」
        における情報の取り扱いを説明するものです。本サイトは非公式ファンサイトです。
      </p>

      <section>
        <h2>取得する情報</h2>
        <p>
          Googleログインを利用する場合、本サイトはGoogleアカウントからメールアドレス、名前、アバター画像を取得します。
          また、利用状況に応じて、保存デッキ、公開デッキ、ニックネーム、大会成績などの利用者が登録または公開した情報を扱います。
        </p>
      </section>

      <section>
        <h2>利用目的</h2>
        <p>
          取得した情報は、ログイン状態の確認、本人識別、デッキ保存、公開デッキ表示、大会成績表示、不正利用の防止、
          サイト運営上必要な連絡、機能改善のために利用します。
        </p>
      </section>

      <section>
        <h2>Cookie・セッション</h2>
        <p>
          本サイトは、認証状態の維持、画面表示の調整、利用者設定の保存のためにCookie、ローカルストレージ、
          セッション情報を利用する場合があります。
        </p>
      </section>

      <section>
        <h2>アクセス解析</h2>
        <p>
          本サイトは、利用状況の把握と改善のために、Googleが提供するアクセス解析ツール
          「Googleアナリティクス」(GA4)を利用しています。Googleアナリティクスは
          Cookieを利用して閲覧状況の情報を収集しますが、この情報に氏名やメールアドレスは含まれず、
          個人を直接特定する目的では利用しません。
        </p>
        <p>
          収集される情報とGoogleにおける取り扱いについては
          <a href={GA_DATA_USE_URL} target="_blank" rel="noreferrer">
            Googleのポリシーと規約
          </a>
          をご覧ください。収集を望まない場合は
          <a href={GA_OPT_OUT_URL} target="_blank" rel="noreferrer">
            Googleアナリティクス オプトアウト アドオン
          </a>
          で無効にできます。
        </p>
      </section>

      <section>
        <h2>公開される情報</h2>
        <p>
          利用者が公開したデッキ、ニックネーム、大会成績は、他の利用者や閲覧者に表示される場合があります。
          公開範囲を理解したうえで、公開してよい内容のみ登録してください。
        </p>
      </section>

      <section>
        <h2>削除依頼</h2>
          <p>
            保存したデッキと公開したデッキは、デッキ構築画面の「読み込み」からご自身で削除できます。
            ニックネームはマイページでいつでも変更でき、過去の大会での表示名も変更後の名前になります。
          </p>
          <p>
            大会の参加記録と、大会に提出したデッキリストは、大会の記録として残るため削除できません。
            他の参加者の成績計算に関わるためです。
          </p>
        {deletionFormUrl ? (
          <p>
            アカウント(メールアドレスとGoogleアカウントとの紐付け)の削除は、
            <a href={deletionFormUrl} target="_blank" rel="noreferrer">
              削除依頼フォーム
            </a>
            からご依頼ください。ご自身で削除する機能がないため、この依頼により対応します。
            本人確認を行ったうえで、合理的な範囲で対応します。
          </p>
        ) : (
          <p>
            アカウント(メールアドレスとGoogleアカウントとの紐付け)の削除依頼窓口は準備中です。
            窓口公開後、本人確認を行ったうえで合理的な範囲で対応します。
          </p>
        )}
      </section>

      <section>
        <h2>本ポリシーの変更</h2>
        <p>
          取り扱う情報や利用するサービスの変更に応じて、このポリシーを変更することがあります。
          変更後の内容は、このページに掲載した時点から適用します。
          内容は随時このページでご確認ください。
        </p>
      </section>

      <section>
        <h2>免責事項と権利表記</h2>
        <p>
          本サイトは情報の正確性、継続性、完全性を保証しません。ガンダムは創通・サンライズの登録商標です。
          本サイトは創通、サンライズ、その他権利者とは関係のない非公式ファンサイトです。
        </p>
      </section>

      <p className="legal-page-date">制定日: {LEGAL_ESTABLISHED_DATE}</p>
    </main>
  );
};

export default Privacy;
